import {
  FETCH_TRANSFER_STATUS_LIST_PENDING,
  FETCH_TRANSFER_STATUS_LIST_REJECTED,
  FETCH_TRANSFER_STATUS_LIST_FULFILLED
} from "../constants/transferStatuses";

const initialState = {
  pending: true,
  transferStatuses: [],
  error: {}
};

export const transferStatuses = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSFER_STATUS_LIST_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_TRANSFER_STATUS_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_TRANSFER_STATUS_LIST_FULFILLED:
      return {
        ...state,
        transferStatuses: action.response.results,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transferStatuses.js